import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { _ } from '/@/locale';
import { MuiAutocomplete } from '/@/mui/autocomplete';

export const generateOptionsKeyValue = (value, cropMonitorings) => {
    let unique = [];
    if (value === 'product') {
        unique = [
            ...new Set(
                cropMonitorings.map((cms) => {
                    return cms.productName;
                })
            ),
        ];
    } else if (value === 'fieldName') {
        unique = [
            ...new Set(
                cropMonitorings.map((cms) => {
                    return cms.fieldName;
                })
            ),
        ];
    } else if (value === 'created') {
        unique = [
            ...new Set(
                cropMonitorings.map((item) => (item.created ? item.created.split('T')?.[0]?.replaceAll('-', '/') : ''))
            ),
        ];
    } else {
        unique = [...new Set(cropMonitorings.map((item) => item[value]))];
    }
    const uniqueValues = unique
        .map((uni) => ({
            value: uni,
            label: uni,
        }))
        .sort((a, b) => {
            if (value === 'plantingDate') return new Date(a.value) - new Date(b.value);
            if (value === 'created') return new Date(a.value) - new Date(b.value);
            return a.value.localeCompare(b.value);
        });
    return uniqueValues;
};

const CropMonitoringFilter = ({ cropMonitorings, onChangeFilters, filters, resetFilters }) => {
    const PHENOLOGICAL_STATES = {
        fallow: _('Barbecho'),
        sowing: _('Siembra'),
        emergence: _('Emergencia'),
        vegetative: _('Vegetativo'),
        flowering: _('Floración'),
        maturity: _('Madurez fisiológica'),
        harvested: _('Cosechado'),
    };

    const applyFilter = (filter, value) => {
        onChangeFilters({
            ...filters,
            [filter]: value,
        });
    };

    return (
        <Grid container spacing={2} direction='column'>
            <Grid item>
                <Grid container spacing={2} direction='row' justifyContent='flex-start' alignItems='center'>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                        <MuiAutocomplete
                            size='small'
                            value={filters['created']}
                            options={generateOptionsKeyValue('created', cropMonitorings)}
                            onChange={(_, option) => applyFilter('created', (option && option.value) || undefined)}
                            label={_('Fecha de creación')}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                        <MuiAutocomplete
                            size='small'
                            value={filters['plantingDate']}
                            options={generateOptionsKeyValue('plantingDate', cropMonitorings)}
                            onChange={(_, option) => applyFilter('plantingDate', (option && option.value) || undefined)}
                            label={_('Fecha de siembra')}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <MuiAutocomplete
                            size='small'
                            value={filters['fieldName']}
                            options={generateOptionsKeyValue('fieldName', cropMonitorings)}
                            onChange={(_, option) => applyFilter('fieldName', (option && option.value) || undefined)}
                            label={_('Lote')}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <MuiAutocomplete
                            size='small'
                            value={filters['product']}
                            options={generateOptionsKeyValue('product', cropMonitorings)}
                            onChange={(_, option) => applyFilter('product', (option && option.value) || undefined)}
                            label={_('Producto')}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                        <MuiAutocomplete
                            size='small'
                            value={filters['phenologicalState']}
                            options={Object.keys(PHENOLOGICAL_STATES).map((key) => ({
                                label: PHENOLOGICAL_STATES[key],
                                value: key,
                            }))}
                            onChange={(_, option) =>
                                applyFilter('phenologicalState', (option && option.value) || undefined)
                            }
                            label={_('Estado')}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Grid item xs={12}>
                    <Button variant='text' onClick={() => resetFilters()}>
                        {_('Limpiar filtros')}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default CropMonitoringFilter;
